import { useTranslation } from 'react-i18next'
import { Link } from "react-router-dom" 

const ButtonQuote = () => {
    const { t } = useTranslation() 

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        })
    }
    
    return (
        <div className='w-max cursor-pointer -rotate-90 sticky top-20 left-full z-40' onClick={() => scrollToTop()}>
            <Link to={'/quote'}>
                <button className='w-max h-max bg-accent p-4 rounded-l-md text-white text-sm rotate-90'>{ t('button_quote') }</button>
            </Link>
        </div>
    )    
}

export default ButtonQuote